(function () {
  function syncOzeraHeaderCartTotal() {
    var el = document.querySelector('[data-header-cart-total]');
    if (!el) return;
    var url = (window.shopUrl || '') + '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (
          typeof Shopify !== 'undefined' &&
          Shopify.formatMoney &&
          window.cartStrings &&
          window.cartStrings.money_format
        ) {
          el.textContent = Shopify.formatMoney(
            cart.total_price,
            window.cartStrings.money_format
          );
        } else {
          el.textContent = (cart.total_price / 100).toFixed(2);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', syncOzeraHeaderCartTotal);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncOzeraHeaderCartTotal();
    });
  }
})();
